export const ACCORDION__HEADING_CLASS = 'accordion__heading';
// Note: changing this could affect tracking (https://notonthehighstreet.atlassian.net/browse/FFA-514?focusedCommentId=54133)
export const ACCORDION__TITLE_CLASS = 'accordion__title';
export const ACCORDION__CONTENT_WRAPPER_CLASS = 'accordion__content-wrapper';
